// A single filled-style calendar glyph for the calendar header chip.
import type { SVGProps } from "react";

export const IconCalendarBlank = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden width="22" height="22" {...props}>
    <rect x="3.5" y="5" width="17" height="15" rx="3.2" fill="currentColor" opacity="0.18" />
    <rect x="3.5" y="5" width="17" height="15" rx="3.2" stroke="currentColor" strokeWidth="2" />
    <path d="M3.5 9.5h17M8 3v3.5M16 3v3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="8" cy="13.5" r="1.2" fill="currentColor" />
    <circle cx="12" cy="13.5" r="1.2" fill="currentColor" />
    <circle cx="16" cy="13.5" r="1.2" fill="currentColor" />
  </svg>
);
